import { Component, OnInit } from '@angular/core';
import {ModalExtended} from 'ngx-dynamic-modal';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ActionHistoryService} from '../../action-history/action-history.service';
import {AlertaService} from '../../../services/alerta.service';
import {DatesParserService} from '../../../../core/service/dates_parser.service';

@Component({
  selector: 'app-edit-action-history-modal',
  templateUrl: './edit-action-history-modal.component.html',
  styleUrls: ['./edit-action-history-modal.component.scss']
})
export class EditActionHistoryModalComponent extends ModalExtended implements OnInit {

    data:any;
    formSearch:FormGroup;
    params:any;

  constructor(private actionHandler: ActionHistoryService, private alerta: AlertaService, private dateParser: DatesParserService) {
    super();
    this.formSearch=new FormGroup(
        {
            'service_pk':new FormControl('',Validators.required),
            'label':new FormControl('',Validators.required),
            'date': new FormControl('', Validators.required),
            'description':new FormControl()
        }
    )
  }

  ngOnInit() {
      this.params=this.data.params;
      if(this.data.element){
          this.formSearch.controls['service_pk'].setValue(this.data.element.service_pk);
          this.formSearch.controls['label'].setValue(this.data.element.label);
          this.formSearch.controls['description'].setValue(this.data.element.description);
          this.formSearch.controls['date'].setValue(this.data.element.date);
      }
  }
  saveData(form){
        if(form.valid){
            let element = this.dateParser.cleanDates(form.value, ['date'], false);
            element['portal_pk']=this.params.portal_pk;
            this.actionHandler.postAction(element)
                .subscribe(result=>{
                    this.onExit({edit:false,element:result.data});
                }, error => {
                    //console.log(error);
                    this.alerta.addAlert('error','Something went wrong')
                }, () => {
                    this.alerta.addAlert('success','Action History Created Succesfully!!')
                })
        }
  }

  updateData(form){
        if(form.valid) {
            let element = this.dateParser.cleanDates(form.value, ['date'], false);
            element['pk']=this.data.element.pk;
            this.actionHandler.putAction(element)
                .subscribe(result => {
                    this.onExit({edit:true,element:result.data});
                }, error => {
                    //console.log(error);
                    this.alerta.addAlert('error','Something went wrong')
                }, () => {
                    this.alerta.addAlert('success','Action History Updated Succesfully!!')
                })
        }
  }

  onExit(data){
      this.applyCallback(data);
      this.close();
  }



}



// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/components/modals/edit-action-history-modal/edit-action-history-modal.component.ts